import axios from "axios";
import { BASE_URL, HEADERS } from "../../src/Utils/UrlUtils";

export const saveCandidateFeedback = (data) => {
    const URI = "/result/feedback";
    return axios.post(BASE_URL + URI, data,HEADERS());
}

export const saveOrUpdateAnswerSelection = (obj) => {
    const URI = "/assesment/saveSelectedAnswer";
    return axios.post(BASE_URL + URI, obj, HEADERS());
}

export const resetSelectedOptions = (obj) => {
    const URI = "/assesment/resetSelectedOptions";

    return axios.post(BASE_URL + URI, obj, HEADERS());
}



export const saveOrUpdateTestAssesmentSnaps = (data) => {
    const URI = "/am/saveOrUpdateTestAssesmentSnaps";

    return axios.post(BASE_URL + URI, data, HEADERS());
}